import QueuedVideo from "./QueuedVideo";

const Queue = ({socket, queue}) => {

    return (
        <>
            {queue.length > 0 ?
                queue.map((video, index) => (<QueuedVideo key={video.queueUUID} index={index} video={video} socket={socket}/>)) : <p className='EmptyQueue'>No Videos Queued</p>
            }
        </>
    )
}

export default Queue;